<template>
    <v-simple-table>
        <template #default>
            <thead>
                <tr>
                    <th>Rank</th>
                    <th>Name</th>
                    <th v-if="resultCategory.event === 'TS'">Name</th>
                    <th>Club</th>
                    <th v-if="resultCategory.event === 'TS'">Club</th>
                    <th>#</th>
                    <th>Execution</th>
                    <th v-if="resultCategory.event === 'TI'">HD</th>
                    <th v-if="resultCategory.event === 'TI'">ToF</th>
                    <th v-if="resultCategory.event === 'TS'">Sync 1</th>
                    <th v-if="resultCategory.event === 'TS'">Sync 2</th>
                    <th>DD</th>
                    <th>ND</th>
                    <th>Score</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="result in results" :key="result.id">
                    <td>{{ result[`${round}_placement`] }}</td>
                    <td>
                        <inertia-link :href="`/athletes/${result.athlete_id}`">{{ result.athlete?.name }}</inertia-link>
                    </td>
                    <td v-if="resultCategory.event === 'TS'">
                        <inertia-link :href="`/athletes/${result.athlete_2_id}`">{{
                            result.athlete2?.name
                        }}</inertia-link>
                    </td>
                    <td>
                        <inertia-link :href="`/clubs/${result.club_id}`">{{ result.club?.name }}</inertia-link>
                    </td>
                    <td v-if="resultCategory.event === 'TS'">
                        <inertia-link :href="`/clubs/${result.club_2_id}`">{{ result.club?.name }}</inertia-link>
                    </td>
                    <td>
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-num`">
                            {{ routine.num }}
                        </div>
                    </td>
                    <td>
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-execution`">
                            {{ formatted(routine, 'execution') }}
                        </div>
                    </td>
                    <td v-if="resultCategory.event === 'TI'">
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-hd`">
                            {{ formatted(routine, 'hd') }}
                        </div>
                    </td>
                    <td v-if="resultCategory.event === 'TI'">
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-tof`">
                            {{ formatted(routine, 'tof') }}
                        </div>
                    </td>
                    <td v-if="resultCategory.event === 'TS'">
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-sync1`">
                            {{ formatted(routine, 'sync1') }}
                        </div>
                    </td>
                    <td v-if="resultCategory.event === 'TS'">
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-sync2`">
                            {{ formatted(routine, 'sync2') }}
                        </div>
                    </td>
                    <td>
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-dd`">
                            {{ formatted(routine, 'dd') }}
                        </div>
                    </td>
                    <td>
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-nd`">
                            {{ formatted(routine, 'nd') }}
                        </div>
                    </td>
                    <td>
                        <div v-for="routine in scoresForRound(result)" :key="`${scores}-${routine.id}-score`">
                            {{ formatted(routine, 'total') }}
                        </div>
                    </td>
                    <td>
                        {{ result[`${round}_score`] }}
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
import { snakeCase } from 'change-case';
import numeral from 'numeral';
import { routineRelationship } from '@/helpers.js';
import ResultCategory from '@/Models/ResultCategory.js';

export default {
    name: 'FullResultsTable',

    props: {
        resultCategory: {
            type: ResultCategory,
            required: true,
        },

        meetId: {
            type: Number,
            required: true,
        },

        round: {
            type: String,
            required: true,
        },

        results: {
            type: Array,
            required: true,
        },
    },

    computed: {
        scores() {
            return snakeCase(routineRelationship(this.resultCategory.event));
        },
    },

    methods: {
        scoresForRound(result) {
            return result[this.scores].filter(score => score.round === this.round);
        },

        formatted(routine, field) {
            const precision3 = [
                'tof',
                'prelims_score',
                'finals_score',
                'total_score',
                'execution',
                'new_life_finals_score',
                'total',
            ];

            if (precision3.includes(field)) {
                return numeral(routine[field]).format('0.000');
            }

            return numeral(routine[field]).format('0.0');
        },
    },
};
</script>
